import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, useNavigate, Link, Navigate } from "react-router-dom";

// components
// import Home from "./pages/Home";
import Auth from "./modules/users/Auth";
import Header from "./components/Header/Header";
// import Panel from "./AdminPanel/Panel";
// import Blog from "./pages/Blog";

// contexts
import AuthContext from "./contexts/authContext";
import { UserData } from "./contexts/UserInfoContext";
import CartContext from "./contexts/CartContext";

// api
import config from "./modules/users/config.json";
import { getData } from "./services/API";

// local storage functions
import {
  removeItemStorage,
  setItemStorage,
} from "./Localstorage/useLocalStorage";
import { useContext } from "react";
import BlogPost from "./components/Blog/BlogPost";
import BlogArchive from "./components/Blog/BlogArchive";
// import UserPanel from "./UserPanel/UserPanel";
import ProductPage from "./pages/ProductPage";
// import Products from "./pages/Products";
import Cart from "./pages/Cart";
import ProtectedRoutes from "./Routes/ProtectedRoutes";
import AdminRoutes from "./Routes/AdminRoutes";
import Design from "./pages/Design";
// import AboutUs from "./pages/AboutUs";
// import ContactUs from "./pages/ContactUs";
import Consultants from "./pages/Consultants";
import AccessContext from "./contexts/AccessContext";
// import Faq from "./pages/Faq";
import CompareContext from "./contexts/CompareContext";
import Loading from "./components/shared/Loading";
import { lazy } from "react";
// import Favourite from "./pages/Favourite";
import FavouriteContext from "./contexts/FavouriteContext";
// import Academy from "./pages/Academy";
import AcademyPage from "./pages/AcademyPage";
import PageLoading from "./components/shared/PageLoading";
import SiteInfoContext from "./contexts/SiteInfoContext";
import TeacherProfile from "./pages/TeacherProfile";
import EpisodePage from "./pages/EpisodePage";
import NewAcademyPage from "./pages/NewAcademyPage";
import Magazine from "./pages/Magazine";
import RefContext from "./contexts/RefContext";
import ResumeContext from "./contexts/ResumeContext";
import ResumePerview from "./pages/ResumePerview";
import HRPage from "./pages/HRPage";
import DiscResult from "./pages/DiscResult";
import SuccessPayment from "./pages/SuccessPayment";
import PrintOrder from "./components/Order/PrintOrder";
import WebDesign from "./pages/WebDesign";
import JoinRequest from "./pages/JoinRequest";
import FacultyResume from "./pages/FacultyResume";
import FacultyLicense from "./pages/FacultyLicense";
import Webinar from "./pages/Webinar";
import Payment from "./pages/Payment";
import Live from "./pages/Live";

const Panel = lazy(() => import("./AdminPanel/Panel"));
const UserPanel = lazy(() => import("./UserPanel/UserPanel"));
const Products = lazy(() => import("./pages/Products"));
const Blog = lazy(() => import("./pages/Blog"));
const NewBlog = lazy(() => import("./pages/NewBlog"));
const Home = lazy(() => import("./pages/Home"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Academy = lazy(() => import("./pages/Academy"));
const Faq = lazy(() => import("./pages/Faq"));
const Favourite = lazy(() => import("./pages/Favourite"));

const App = () => {
  const {
    api_url: { g_user_profile },
  } = config;

  const { user, setUser, userLoaded } = useContext(UserData);

  const navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState(null);
  const [userInfo, setUserInfo] = useState({});
  const [formFields, setFormFields] = useState([]);

  // get user data
  const getUserData = () => {
    getData(g_user_profile.url, {}, true)
      .then((res) => {
        setUser({ ...res.data.data.user });
        navigate("/user");
      })
      .catch((err) => {});
  };

  const userPhoneNumber = (res, userPhone) => {
    setUserInfo({ phone_number: userPhone });
    setFormFields(res.data?.reg_form_fields);
  };

  const userLogin = (res) => {
    setToken(res.token);
    setItemStorage("token", res.token);
    setIsLoggedIn(true);
  };

  const userVerify = (res, code) => {
    if (res.status === "success") {
      setUserInfo({ ...userInfo, completeProfile: true, vcode: code });
    }
  };

  const userCompleteProfile = (res, userData) => {
    setUserInfo({ ...userInfo, ...userData });
    setToken(res.token);
    setItemStorage("token", res.token);
    setIsLoggedIn(true);
  };

  const userPasswordRecovery = (userData) => {
    setToken(userData.token);
    setItemStorage("token", userData.token);
    setIsLoggedIn(true);
  };

  const userLogout = () => {
    setIsLoggedIn(false);
    setToken(null);
    setUserInfo({ ...userInfo, completeProfile: false });
  };

  return (
    <div className="App">
      <AuthContext.Provider
        value={{
          isLoggedIn,
          userInfo,
          token,
          formFields,
          userPhoneNumber,
          userLogin,
          userVerify,
          userCompleteProfile,
          userLogout,
          userPasswordRecovery,
        }}
      >
        <CartContext>
          <AccessContext>
            <CompareContext>
              <RefContext>
                <FavouriteContext>
                  <SiteInfoContext>
                    <ResumeContext>
                      <Routes>
                        <Route
                          path="/"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Home />
                            </Suspense>
                          }
                        />
                        <Route path="/auth" element={<Auth />} />
                        <Route path="/web-design" element={<WebDesign />} />
                        <Route path="/auth-ref/:ref" element={<Auth />} />
                        <Route path="/panel/:username" element={<Auth />} />
                        <Route
                          path="/news"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Blog type={1} />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/magazine"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Magazine type={2} />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/new-blog"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <NewBlog />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/news-category/:slug"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Blog type={1} />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/magazine-category/:slug"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Magazine type={2} />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/shop"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Products />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/shop-category/:slug"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Products />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/courses"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Academy />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/courses-category/:slug"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Academy />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/about-us"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <AboutUs />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/contact-us"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <ContactUs />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/courses/:slug"
                          element={<NewAcademyPage />}
                        />
                        <Route path="/cart" element={<Cart />} />
                        <Route path="/shop/:slug" element={<ProductPage />} />
                        <Route path="/news/:postSlug" element={<BlogPost />} />
                        <Route
                          path="/magazine/:postSlug"
                          element={<BlogPost />}
                        />
                        <Route
                          path="/order/payment"
                          element={<SuccessPayment />}
                        />
                        <Route path="/invoice-print" element={<PrintOrder />} />

                        <Route path="/disc-result" element={<DiscResult />} />
                        <Route
                          path="/teacher-profile/:slug"
                          element={<TeacherProfile />}
                        />
                        <Route path="/ep/:slug" element={<EpisodePage />} />
                        <Route
                          path="/resume-perview/:userId"
                          element={<ResumePerview />}
                        />
                        <Route
                          path="/faculty-resume/:id"
                          element={<FacultyResume />}
                        />
                        <Route
                          path="/faculty-lic/:id"
                          element={<FacultyLicense />}
                        />
                        <Route
                          path="/live"
                          element={<Live />}
                        />
                        <Route path="/design" element={<Design />} />
                        <Route path="/hr-land" element={<HRPage />} />
                        {/* <Route path="/webinar" element={<Webinar />} /> */}
                        <Route path="/pay" element={<Payment />} />
                        <Route path="/faculty" element={<JoinRequest />} />
                        <Route
                          path="/faq"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Faq />
                            </Suspense>
                          }
                        />
                        <Route
                          path="/favourite"
                          element={
                            <Suspense fallback={<PageLoading />}>
                              <Favourite />
                            </Suspense>
                          }
                        />
                        <Route element={<AdminRoutes />}>
                          <Route
                            path="/admin/*"
                            element={
                              <Suspense fallback={<PageLoading />}>
                                <Panel />
                              </Suspense>
                            }
                          />
                        </Route>
                        <Route element={<ProtectedRoutes />}>
                          <Route
                            path="/user/*"
                            element={
                              <Suspense fallback={<PageLoading />}>
                                <UserPanel />
                              </Suspense>
                            }
                          />
                        </Route>
                      </Routes>
                    </ResumeContext>
                  </SiteInfoContext>
                </FavouriteContext>
              </RefContext>
            </CompareContext>
          </AccessContext>
        </CartContext>
      </AuthContext.Provider>
    </div>
  );
};

export default App;
